var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCheckmarkWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.61522 4.36522 0.25 9.75 0.25C15.1348 0.25 19.5 4.61522 19.5 10C19.5 15.3848 15.1348 19.75 9.75 19.75C4.36522 19.75 0 15.3848 0 10ZM13.3357 8.46852C13.5944 8.14507 13.542 7.67311 13.2185 7.41435C12.8951 7.15559 12.4231 7.20803 12.1643 7.53148L8.68781 11.8772L7.28033 10.4697C6.98744 10.1768 6.51256 10.1768 6.21967 10.4697C5.92678 10.7626 5.92678 11.2374 6.21967 11.5303L8.21967 13.5303C8.37052 13.6812 8.57847 13.7606 8.79148 13.7489C9.00448 13.7371 9.20238 13.6351 9.33565 13.4685L13.3357 8.46852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckmarkWhite);
export default __webpack_public_path__ + "static/media/successCheckmarkWhite.55672a03a3d7399e457563c4c1508be0.svg";
export { ForwardRef as ReactComponent };